import { EM } from "resource-planner-model";
import {
  EMAction,
  EMsState,
  FETCH_EMS,
  LOAD_EMS,
  PERSIST_EM,
  REMOVE_EM,
  REMOVE_EM_LOCAL,
  UPSERT_EM
} from "./EMsTypes";

const initialState: EMsState = {
  items: {},
  loadedAll: false,
  nextToken: undefined,
  synching: false,
};

export default function emsReducer(
  state = initialState,
  action: EMAction
): EMsState {
  switch (action.type) {
    case FETCH_EMS:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_EM:
      return {
        ...state,
        synching: true,
      };
    case PERSIST_EM:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_EM_LOCAL: {
      const items = { ...state.items };
      delete items[action.id];
      return {
        ...state,
        items,
        synching: false,
      };
    }
    case UPSERT_EM:
      return {
        ...state,
        items: {
          ...state.items,
          [action.item.id]: action.item,
        },
        synching: false,
      };
    case LOAD_EMS:
      return {
        ...state,
        items: action.items.reduce((all: { [id: string]: EM }, item) => {
          const oneYearAgo = new Date();
          oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
          if(!item.offboardDate || (
            item.offboardDate &&
            new Date(item.offboardDate.year, item.offboardDate.month - 1, item.offboardDate.day) >= oneYearAgo
          ))
          {
            all[item.id] = item;
          }

          return all;
        }, action.append ? { ...state.items } : {}),
        loadedAll: action.loadedAll || false,
        nextToken: action.nextToken,
        synching: false,
      };
    default:
      return state;
  }
}
